import { BOARDS } from '@/data/content';

const boardColorText: Record<string, string> = { 'board-a': 'text-board-a', 'board-b': 'text-board-b', 'board-c': 'text-board-c', 'board-s': 'text-board-s' };
const boardColorBg: Record<string, string> = { 'board-a': 'bg-board-a/8', 'board-b': 'bg-board-b/8', 'board-c': 'bg-board-c/8', 'board-s': 'bg-board-s/8' };
const boardColorBorder: Record<string, string> = { 'board-a': 'border-board-a/30', 'board-b': 'border-board-b/30', 'board-c': 'border-board-c/30', 'board-s': 'border-board-s/30' };

export default function ProductsPage() {
 return (
 <div >
 {/* Assembly video hero - full width */}
 <div className="relative overflow-hidden w-full h-[540px] md:h-[660px] mb-8">
 <img src="/images/hero_exploded.webp" alt="" className="absolute inset-0 w-full h-full object-cover md:hidden" />
<video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover hidden md:block">
 <source src="/videos/exploded-assembly.webm" type="video/webm" />
<source src="/videos/exploded-assembly.mp4" type="video/mp4" />
 </video>
 <div className="absolute inset-0 bg-black/45" />
 {/* Title overlay */}
 <div className="absolute top-0 left-0 right-0 p-8 md:p-12 text-center bg-gradient-to-b from-black/60 to-transparent">
 <h1 className="text-2xl md:text-3xl font-extrabold text-white mb-3 drop-shadow-[0_0_30px_rgba(0,0,0,0.8)]">产品体系</h1>
 <p className="text-white/80 text-sm max-w-2xl mx-auto drop-shadow-lg sm:whitespace-nowrap">一块底盘，四种大脑。从免工具拼装到双芯片架构，一辆战车承载从小学到大学的全年龄段进化。</p>
 </div>
 {/* Bottom caption */}
 <div className="absolute bottom-0 left-0 right-0 pb-6 text-center">
 <p className="text-white/90 text-sm font-medium drop-shadow-lg">15 分钟免工具拼装 · 每一个零件都可以独立更换</p>
 </div>
 </div>

 <section className="px-6 py-12 max-w-6xl mx-auto">
 {/* Video hero */}
 <div className="relative mb-8 rounded-card-lg overflow-hidden h-[540px] md:h-[660px]">
 <img src="/images/board_a.webp" alt="" className="absolute inset-0 w-full h-full object-cover md:hidden" />
<video autoPlay muted loop playsInline className="absolute inset-0 w-full h-full object-cover hidden md:block">
 <source src="/videos/boards-evolution.webm" type="video/webm" />
<source src="/videos/boards-evolution.mp4" type="video/mp4" />
 </video>
 <div className="absolute inset-0 bg-black/50" />
 <div className="absolute inset-0 flex items-center justify-center">
 <h2 className="text-2xl font-extrabold text-white drop-shadow-[0_0_30px_rgba(0,0,0,0.8)]">四档主板</h2>
 </div>
 </div>
 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
 {BOARDS.map((b, i) => (
 <div key={b.id} className="group relative">
 <div className={`flex flex-col h-full bg-panel-dark/40 border rounded-card-lg mecha-card mecha-bolt overflow-hidden transition-all duration-300 group-hover:scale-105 group-hover:-translate-y-2 group-hover:z-20 group-hover:shadow-[0_8px_40px_rgba(0,0,0,0.5)] group-hover:border-arena-blue/30 ${boardColorBorder[b.color]}`}>
 <div className={`h-28 flex items-center justify-center relative shrink-0 ${boardColorBg[b.color]}`}>
 <img src={b.image} alt={b.name} className="h-24 w-auto object-contain transition-transform duration-300 group-hover:scale-110" />
 {i < BOARDS.length - 1 && <div className="hidden lg:block absolute -right-2 top-1/2 -translate-y-1/2 z-10 text-border-dark"><svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14M13 5l7 7-7 7"/></svg></div>}
 </div>
 <div className="p-4 flex flex-col flex-1">
 <div className="flex items-center gap-2 mb-2"><span className={`text-lg font-extrabold ${boardColorText[b.color]}`}>{b.id} 板</span><span className="text-[11px] text-text-disabled">{b.ageGroup}</span></div>
 <p className="text-xs text-text-secondary mb-3">{b.subtitle}</p>
 <div className="space-y-1 flex-1">{b.specs.map((s) => (<div key={s.label} className="flex justify-between text-[11px]"><span className="text-text-disabled">{s.label}</span><span className="text-text-secondary text-right ml-2">{s.value}</span></div>))}</div>
 <div className="pt-3 border-t border-border-dark flex items-center justify-between mt-auto"><span className="text-base font-semibold text-text-primary">{b.price}</span><span className="text-[11px] text-text-disabled">{b.programmingLang}</span></div>
 </div>
 </div>
 {/* Hover detail popup */}
 <div className="relative md:absolute md:left-1/2 md:-translate-x-1/2 md:top-full md:mt-2 w-full md:w-64 mt-3 bg-panel-dark border border-arena-blue/30 rounded-card-lg mecha-card mecha-bolt p-4 opacity-100 md:opacity-0 md:group-hover:opacity-100 transition-opacity duration-300 md:pointer-events-none z-30 shadow-[0_8px_30px_rgba(0,0,0,0.6)]">
 <p className="text-xs text-text-primary font-semibold mb-2">{b.name}</p>
 <p className="text-[11px] text-text-secondary leading-relaxed">{b.subtitle}</p>
 <div className="mt-2 pt-2 border-t border-border-dark text-[11px] text-arena-blue/80">{b.programmingLang} · {b.ageGroup}</div>
 </div>
 </div>
 ))}
 </div>
 </section>

 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">技术参数对比</h2>
 <div className="overflow-x-auto mb-8">
 <table className="w-full text-sm border-collapse">
 <thead><tr className="border-b-2 border-border-dark"><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs w-28">参数</th><th className="text-left py-2.5 px-3 text-board-c font-medium text-xs">C 板</th><th className="text-left py-2.5 px-3 text-arena-blue font-medium text-xs">B 板</th><th className="text-left py-2.5 px-3 text-board-a font-medium text-xs">A 板</th><th className="text-left py-2.5 px-3 text-arena-red font-medium text-xs">S 板</th></tr></thead>
 <tbody className="text-text-secondary">
 {[['MCU','GD32E230C8T6','GD32F405RGT6','STM32N6570/K230','RK3566+GD32E230'],['封装','LQFP48','LQFP64','LQFP100','BGA144'],['全功能口','2','4','8','12'],['GPIO 口','2','2','4','4'],['IMU','QMI8658C','ICM-42688-P','ICM-42688-P+MMC5983','BMI088+IST8310'],['无线通信','NRF24L01+','ESP32-C3 (WiFi/BLE)','ESP32-C3 (WiFi/BLE)','AP6256 (WiFi/BLE)'],['摄像头','不支持','OV2640','OV5640 (MIPI)','OV5640 x2 (双目)'],['电机驱动','TB6612FNG','TB6612FNG','DRV8833','DRV8874 x2'],['编程语言','图形化编程','Python','Python / C++','C++ / Rust / RTOS'],['操作系统','Bare Metal','Bare Metal','可选 RTOS','Linux + RTOS'],['主板零售价','含基础版套装','49 - 69','149 - 169','299 - 349']].map((row,i)=>(<tr key={i} className="border-b border-border-dark/50 hover:bg-panel-mid/50 transition-colors"><td className="py-2.5 px-3 text-text-disabled text-xs font-medium">{row[0]}</td>{row.slice(1).map((cell,j)=>(<td key={j} className="py-2.5 px-3 text-xs">{cell}</td>))}</tr>))}
 </tbody>
 </table>
 </div>
 </section>

 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">基础版套装</h2>
 	 {/* Main content - full width */}
	 <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg mecha-card mecha-bolt p-6 mb-4">
	 <p className="text-sm text-text-secondary mb-4">零售 ¥XX。适合学校批量采购和 C 端入门。</p>
	 <div className="grid grid-cols-2 sm:grid-cols-3 gap-2 text-xs">{['承载式一体底盘 (ABS/PC)','楔形上壳体 (前低后高)','齿轮减速组 ~10:1','130 电机 x2','18650 电池 (中置滑盖)','TPU 科技色保险杠 x2','橡胶轮胎 x4 (M4 手拧)','C 板 (板载 IMU+2.4G)','遥控手柄','M3 尼龙手拧螺丝 x4','硅胶减震柱 x4','说明书 + 收纳盒'].map((item)=>(<div key={item} className="flex items-center gap-2 text-text-secondary"><div className="w-1 h-1 rounded-full bg-arena-blue/60 shrink-0"/>{item}</div>))}</div>
	 </div>
	 {/* 扩展选购 - 3 horizontal cards */}
	 <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-8">
	   <div className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4"><h3 className="text-sm font-semibold text-text-primary mb-2">传感器扩展包</h3><p className="text-xs text-text-secondary">红外避障 + 颜色识别 + 超声波测距</p></div>
	   <div className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4"><h3 className="text-sm font-semibold text-text-primary mb-2">教师教学套件</h3><p className="text-xs text-text-secondary">全扩展模块 + 备用零件 + B/C 板各 1 + 教案</p></div>
	   <div className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4"><h3 className="text-sm font-semibold text-text-primary mb-2">便携场地包</h3><p className="text-xs text-text-secondary">边界圈 + 赛道标记套装 + 裁判哨子</p></div>
	 </div>
 </section>

 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">生态体系</h2>
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-10">
 {[{t:'主板',sub:'C/B/A/S 四级',d:'官方独占。即插即用，底盘不变，主板决定能力上限。',c:'#FF3B3B'},{t:'核心电子',sub:'电机/电池/传感器',d:'官方销售。动力与感知系统，品质统一保障安全与兼容性。',c:'#FFB800'},{t:'结构件',sub:'装甲/轮胎/悬挂',d:'社区共创+佣金。3D打印或注塑，被采纳即获15%-25%分成。',c:'#00C2FF'},{t:'程序',sub:'策略/算法/固件',d:'社区共创+佣金。从PID调参到强化学习，代码即战力。',c:'#00E676'}].map((e)=>(<div key={e.t} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-5"><div className="w-2 h-2 rounded-full mb-3" style={{backgroundColor:e.c}}/><h3 className="text-sm font-semibold text-text-primary">{e.t}</h3><p className="text-[11px] text-text-disabled mb-2">{e.sub}</p><p className="text-xs text-text-secondary leading-relaxed">{e.d}</p></div>))}
 </div>
 </section>

 {/* ---- Control Methods ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">操控方式</h2>
 <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
 {[
 { b:'C 板', c:'NRF 2.4G 遥控器（唯一方式）', d:'实体遥控器，1 摇杆 + 4 按钮，出厂空白' },
 { b:'B 板', c:'BLE 遥控器 + Python/UDP（可选）', d:'装上摄像头后可手写 Python 代码接管控制' },
 { b:'A 板', c:'BLE 遥控器 + Python/UDP（默认）', d:'双模操控，代码控制为主遥控器兜底' },
 { b:'S 板', c:'SSH/ROS + 遥控器兜底', d:'完全软件定义，遥控器仅作安全备份' },
 ].map((x) => (
 <div key={x.b} className="bg-panel-dark/40 border border-border-dark rounded-card-lg p-5">
 <h3 className="text-sm font-extrabold text-arena-blue mb-2">{x.b}</h3>
 <p className="text-xs text-text-secondary mb-2">{x.c}</p>
 <p className="text-[11px] text-text-disabled">{x.d}</p>
 </div>
 ))}
 </div>
 </section>

 {/* ---- Camera & Gimbal ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">摄像头与云台</h2>
 <div className="overflow-x-auto mb-4">
 <table className="w-full text-sm border-collapse">
 <thead><tr className="border-b-2 border-border-dark"><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">模块</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">适配主板</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">接口</th><th className="text-left py-2.5 px-3 text-text-disabled font-medium text-xs">说明</th></tr></thead>
 <tbody className="text-text-secondary text-xs">
 {[
 ['OV2640 摄像头','B / A / S','FPC 排线','200万像素，基础视觉入门'],
 ['OV5640 摄像头','A / S','MIPI','500万像素，高清视觉+目标识别'],
 ['单轴舵机云台','C / B / A / S','GPIO PWM','SG90，水平旋转，摄像头左右扫描'],
 ['双轴舵机云台','B / A / S','GPIO PWM x2','SG90 x2，水平+俯仰，目标追踪'],
 ['云台安装支架','全','壳体顶部 12 孔位','ABS 注塑，免工具手拧固定'],
 ].map((r,i)=>(<tr key={i} className="border-b border-border-dark/50 hover:bg-panel-mid/50"><td className="py-2.5 px-3 text-text-primary">{r[0]}</td><td className="py-2.5 px-3">{r[1]}</td><td className="py-2.5 px-3">{r[2]}</td><td className="py-2.5 px-3 font-mono">{r[3]}</td><td className="py-2.5 px-3">{r[4]}</td></tr>))}
 </tbody>
 </table>
 </div>
 <div className="bg-panel-dark/40 border border-border-dark rounded-card-lg p-4 text-xs text-text-secondary">
 <p>C 板不支持摄像头（无 FPC/MIPI 接口），GPIO 可接单轴舵机做简单扫描。B 板开始支持 OV2640 + Python/OpenCV 基础视觉，A 板升级 MIPI 高速接口 + NPU 推理，S 板双目深度视觉 + SLAM。</p>
 </div>
 </section>

 {/* ---- A-board Combat Programming Skills ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">C 板对抗编程技能</h2>
 <p className="text-xs text-text-secondary mb-5 text-center">基础版标配的 C 板可通过编程实现以下竞技技能——不是可有可无的装饰，而是直接决定比赛胜负的战力。</p>
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
 {[
 { cat: '攻击类', color: '#FF3B3B', items: '冲刺助推、撞击后追击、顶牛模式、侧翼突袭、预判走位、冲撞蓄力' },
 { cat: '防御类', color: '#00C2FF', items: '反推系统、防侧翻姿态控制、边界感知制动、陀螺仪自旋防御、低重心贴地模式、假动作晃身' },
 { cat: '反击类', color: '#FFB800', items: '倒地自救、边缘绝地反击、被推走反拉、死角脱困' },
 { cat: '传感器战术', color: '#00E676', items: '自动锁定追击、侧翼警戒、圈边巡弋、角区域封锁' },
 ].map((g) => (
 <div key={g.cat} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4">
 <div className="flex items-center gap-2 mb-3"><div className="w-2 h-2 rounded-full" style={{backgroundColor:g.color}}/><h3 className="text-sm font-semibold text-text-primary">{g.cat}</h3></div>
 <div className="flex flex-wrap gap-1">{g.items.split('、').map((s)=>(<span key={s} className="text-[11px] text-text-secondary bg-panel-mid px-1.5 py-0.5 rounded-tag">{s}</span>))}</div>
 </div>
 ))}
 </div>
 </section>

 {/* ---- Structure Design Principles ---- */}
 <section className="px-6 py-12 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">车辆结构设计原理</h2>
 <p className="text-xs text-text-secondary mb-5 text-center">8 项结构决策，每一项背后都有工程理由。这不仅仅是"这样做"，而是"为什么这样做"。</p>
 <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3">
 {[
 { n:'2.1', t:'承载式一体底盘', d:'零件最少，上手最快。底盘=一整块ABS/PC注塑件，电机主板电池全直接安装。上壳体为覆盖件，不承受碰撞主应力。预留扩展孔位矩阵——"孔位就是创造力"。', c:'#00E676' },
 { n:'2.2', t:'齿轮减速组 ~10:1', d:'直驱扭矩仅10-50 g·cm，推不动对手。减速增扭10倍后达200-500 g·cm。齿轮本身是最便宜的保险丝——过载时齿轮先坏（几毛钱可换），保护电机。', c:'#00C2FF' },
 { n:'2.3', t:'TPU橡胶保险杠', d:'碰撞时橡胶变形吸收能量，保护底盘和主板。独立件插入底盘卡槽，免工具更换。颜色选用科技感配色（荧光绿、暗夜橙、赛博黄、金属灰），与机甲风格统一。', c:'#FFB800' },
 { n:'2.4', t:'电池中置底部', d:'18650电池重约45g（占整车10-15%），放在正中最低处使重心高度最低、前后均匀分布，最大程度降低翻车概率。车底滑盖式更换，免工具。', c:'#FF6D00' },
 { n:'2.5', t:'M4螺纹锁紧车轮', d:'对抗赛中碰撞力度大，D型轴推入式容易掉轮。螺纹锁紧最可靠，尼龙自锁螺母或弹簧垫圈防松。四个车轮统一规格，手拧操作低龄孩子也能完成。', c:'#FF3B3B' },
 { n:'2.6', t:'M3尼龙手拧螺丝', d:'对抗赛碰撞力度大，卡扣式存在被撞开隐患。螺丝最牢固。尼龙材质不生锈，万一碰撞中断掉也只断螺丝不伤壳体——牺牲自己保护别人。', c:'#88929E' },
 { n:'2.7', t:'主板仓三层防护', d:'硬壳封闭仓+四角硅胶减震柱+外层上壳体=三层防护。主板压在减震柱上，四周无硬接触。碰撞时胶柱变形"吃掉"振动——这就是阻尼。', c:'#00C2FF' },
 { n:'2.8', t:'不对称楔形上壳体', d:'前低后高跑车造型，一眼辨认车头方向。底盘主板仓旁同步刻印方向箭头，拼装时双重确认。零成本方案，不需LED指示灯。', c:'#00E676' },
 ].map((p) => (
 <div key={p.n} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-4">
 <div className="flex items-center gap-2 mb-2"><span className="text-xs font-mono font-extrabold" style={{color:p.c}}>{p.n}</span><h3 className="text-sm font-semibold text-text-primary">{p.t}</h3></div>
 <p className="text-xs text-text-secondary leading-relaxed">{p.d}</p>
 </div>
 ))}
 </div>
 </section>

 <section className="px-6 pb-16 max-w-6xl mx-auto">
 <h2 className="text-lg font-extrabold text-text-primary mb-4 text-center">安全与合规</h2>
 <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
 {[{t:'武器限制',d:'少年组仅限碰撞推挤。青少组以上开放推铲、侧翼防护铲等合规武器。全组别禁止旋转武器、尖锐物、喷射物、电磁干扰、电击高热装置。'},{t:'动力锁',d:'少年组标准动力，转速上限锁定。青少组可换电机和齿比。菁英组全部开放。极客组额外开放无刷电机和高电压电池，须通过赛前安全审核。'},{t:'检录流程',d:'方案2/3赛前必须检录：电子秤称重+裁判目视武器合规检查。尺寸不做硬性限制，由重量自行约束。方案3增加主板自动握手认证和力传感器校准。'}].map((s)=>(<div key={s.t} className="bg-panel-dark/40 border border-border-dark rounded-card mecha-card mecha-bolt p-5"><h3 className="text-sm font-semibold text-text-primary mb-3">{s.t}</h3><p className="text-xs text-text-secondary leading-relaxed">{s.d}</p></div>))}
 </div>
 </section>
 </div>
 );
}
